<div class="sun"></div>
<div class="toggler toggler--reverse" (click)="toggleTheme()" [class.active]="darkTheme"></div>
<div class="toggler-mobile" (click)="toggleTheme()"></div>
<div class="moon"></div>
